import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { uploadKycDoc } from "../../../services/settings";
import toast from "react-hot-toast";
import KycFiles from "./KycFiles";

const UploadDoc = () => {
  const [selectedFile, setSelectedFile] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState(false);
  const [docSuccess, setDocSuccess] = useState(false);
  const [active, setActive] = useState(true);
  const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleDocuChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setActive(false);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewFile(reader.result); // Set the preview file data
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("type", "identity");
      formData.append("file", file);

      const response = await uploadKycDoc(formData);
      toast.success(response.message);
      handleUpload();
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleDocuClick = (e) => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    setSelectedFile(false);
    setUploadedFiles(true);
  };

  const handleSuccess = () => {
    setUploadedFiles(false);
    setDocSuccess(true);
  };

  const handleCancel = () => {
    setUploadedFiles(false);
    setSelectedFile(true);
  };

  return (
    <div className="p-[2.5rem] pt-5">
      <section className="md:flex justify-between items-center">
        <div className="font-medium text-3xl">
          Upload the Identification document here
        </div>
        <div className="w-[229px]">
          <button
            className="w-[229px] rounded-[10px] p-2 bg-primary text-white"
            type="button"
          >
            Download kyc form
          </button>
        </div>
      </section>
      <section className="">
        <div className=" pt-[1rem] pb-4 text-base">
          Upload Means of identification for all Ultimate Beneficial Owners
          (e.g., copy of international passport, driver's license, or any
          government-issued ID).
        </div>
        <div className="border border-primary"></div>
      </section>
      {selectedFile && (
        <form onSubmit={handleSubmit}>
          <section className="flex justify-center items-center">
            <div className="flex flex-col items-center">
              <div className="font-medium md:text-xl pt-8">
                Please Upload Identification document
              </div>
              <div class="text-gray-400 max-w-60 md:max-w-full text-sm font-normal pt-2 pb-8">
                Upload your filled Vestrapay Due Diligence Questionnaire and all
                other required document here
              </div>
              <div className="my-8 md:w-[531px] h-[292px] flex flex-col gap-3 justify-center items-center  border border-primary	border-dashed rounded-md	">
                {previewFile ? (
                  <div className="flex flex-col items-center">
                    {file.type.startsWith("image/") ? (
                      <img
                        src={previewFile}
                        alt="Preview"
                        className="max-w-[180px] max-h-[180px]"
                      />
                    ) : (
                      <div className="text-gray-400">{file.name}</div>
                    )}
                  </div>
                ) : (
                  <>
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M32.5 32L24.5 24L16.5 32"
                        stroke="#F58220"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M24.5 24V42"
                        stroke="#F58220"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M41.28 36.78C43.2307 35.7165 44.7717 34.0337 45.6598 31.9972C46.5479 29.9607 46.7325 27.6864 46.1845 25.5334C45.6364 23.3803 44.387 21.471 42.6334 20.1069C40.8797 18.7427 38.7218 18.0014 36.5 18H33.98C33.3747 15.6585 32.2464 13.4846 30.6799 11.642C29.1135 9.79927 27.1497 8.33567 24.9362 7.36118C22.7227 6.3867 20.3171 5.92669 17.9003 6.01573C15.4834 6.10478 13.1182 6.74057 10.9824 7.8753C8.84662 9.01003 6.99586 10.6142 5.56929 12.5671C4.14271 14.5201 3.17742 16.771 2.746 19.1508C2.31458 21.5305 2.42825 23.977 3.07847 26.3065C3.72869 28.636 4.89853 30.7877 6.50004 32.6"
                        stroke="#F58220"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M32.5 32L24.5 24L16.5 32"
                        stroke="#F58220"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p>Select a file or drag and drop here</p>
                    <p className="text-primary text-sm max-w-60 md:max-w-full md:text-base">
                      JPG, PNG or PDF, file size no more than 10MB
                    </p>
                  </>
                )}
                <input
                  type="file"
                  id="upload"
                  name="upload"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  className="hidden"
                  ref={fileInputRef}
                  onChange={handleDocuChange}
                />

                <div
                  className="border border-solid cursor-pointer mt-4 border-[#382C7CB3] p-2 rounded-lg text-primary"
                  onClick={handleDocuClick}
                >
                  SELECT FILE
                </div>
              </div>
              <div className="w-[425px] mt-20 flex justify-center">
                {/* <button className="w-[142px] text-orange-400 border border-orange-400 p-2 rounded-md" type="button">
                  Cancel
                </button> */}

                <button
                  type="submit"
                  className="w-[272px] disabled:bg-[rgba(var(--primary-rgb),0.3)] text-white p-2 rounded-md bg-primary"
                  disabled={active}
                >
                  Upload Document
                </button>
              </div>
            </div>
          </section>
        </form>
      )}

      {uploadedFiles && (
        <KycFiles
          handleSuccess={handleSuccess}
          handleCancel={handleCancel}
          docType="identity"
        />
      )}

      {docSuccess && (
        <form>
          <section className="flex flex-col justify-center mt-20">
            <div className="flex flex-col items-center">
              <div className="font-medium text-xl pt-8">Success!</div>
              <div class="text-gray-400 text-center text-sm font-normal pt-2 pb-8">
                Documents have been uploaded successfully, check <br /> your
                registered email for confirmation.{" "}
              </div>
            </div>
            <section className="flex flex-col justify-center items-center pt-10">
              <div className=" mt-20 flex justify-between">
                <button
                  className="w-[272px] bg-primary text-white p-2 rounded-md"
                  onClick={() => navigate("/settings/profile")}
                >
                  Return To Profile{" "}
                </button>
              </div>
            </section>
          </section>
        </form>
      )}
    </div>
  );
};

export default UploadDoc;
